import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; 
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import 'quill/dist/quill.snow.css';
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
// ✅ 1. PrimeReact THEME

// ✅ 2. PrimeReact core

// 🔹 Tailwind veya kendi CSS’in

 
//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<App />);

ReactDOM.createRoot(document.getElementById("root")).render(
  <AuthProvider>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </AuthProvider>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
